import { SearchInputComponent } from "../components/SearchInput"

import { convertStringToTags } from "./tags"
import { convertSearchToProtocol, getLocation } from "../../searchprotocol"
import { saveSearchQuery } from "../../persist"
import { Labels } from "../../../../util/Translations"
import { ISearchQuery } from "../../index"

export async function doSearch(this: SearchInputComponent): Promise<void> {
    const { requestSearch, normalizedNameLUT, userFullName } = this.props

    const searchInputText = this.getInputText()

    this.setState({
        doingSearch: true,
    })
    const tags = convertStringToTags(normalizedNameLUT, searchInputText)

    saveSearchQuery(searchInputText)

    let location: string | undefined = undefined
    if (tags.find((tag) => tag.fieldType === "geotype") !== undefined) {
        try {
            location = await getLocation()
        } catch (error) {
            this.setState({
                doingSearch: false,
            })
            throw error
        }
    }

    const { SearchKeywordsJSON } = Labels
    const searchJson: ISearchQuery = convertSearchToProtocol(
        normalizedNameLUT,
        tags,
        userFullName,
        location,
        JSON.parse(SearchKeywordsJSON),
    )
    const searchJsonString: string = JSON.stringify(searchJson)
    if (__DEBUG__) {
        console.log(JSON.stringify(searchJson, null, 1))
    }
    requestSearch(searchJsonString)
}
